{
    "RangeCombo_Search_Placeholder": "Zoeken...",
    "NAME": "RangeComboLanguage"
}